import { render, staticRenderFns } from "./SendEmailFileButton.vue?vue&type=template&id=2a4f50d6&scoped=true"
import script from "./SendEmailFileButton.vue?vue&type=script&lang=js"
export * from "./SendEmailFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f50d6",
  null
  
)

export default component.exports